import { AgeContainer, BoxContainer } from "app/pages/website-analysis/demographics/StyledComponents";
import { AgeDistributionBarChart } from "app/pages/website-analysis/demographics/AgeDistributionBarChart/AgeDistributionBarChart";
import type { IAgeDistribution as IAgeDistributionProp } from "app/pages/website-analysis/demographics/types";
import type { FC } from "react";

interface IAgeDistribution {
    ageDistribution: IAgeDistributionProp;
    isLoading: boolean;
    downloadExcelUrl: string;
}
export const AgeDistribution: FC<IAgeDistribution> = (props) => {
    const { isLoading, ageDistribution, downloadExcelUrl } = props;
    return (
        <AgeContainer>
            <BoxContainer>
                <AgeDistributionBarChart
                    ageDistribution={ageDistribution}
                    isLoading={isLoading}
                    downloadExcelUrl={downloadExcelUrl}
                />
            </BoxContainer>
        </AgeContainer>
    );
};
